import { Link } from '@tanstack/react-router'
import type { useProductCardModel } from '@/components/shared/product-card/product-card.model'
import { ProductPlaceholderViewModel } from '@/components/shared/product-placeholder/product-placeholder.view-model'

type ProductCardViewProps = ReturnType<typeof useProductCardModel>

export function ProductCardView({
  product,
  size,
  slug,
  formattedPrice,
}: ProductCardViewProps) {
  return (
    <Link
      to="/produto/$slug"
      params={{ slug }}
      className={`fz-product-card fz-product-card--${size}`}
    >
      <div className="fz-product-card__media">
        {product.imagePath ? (
          <img
            src={product.imagePath}
            alt={product.name}
            className="fz-product-card__image"
            loading="lazy"
          />
        ) : (
          <ProductPlaceholderViewModel
            name={product.name}
            category={product.category}
          />
        )}
      </div>
      <div className="fz-product-card__info">
        <span className="fz-product-card__name">{product.name}</span>
        <span className="fz-product-card__price">{formattedPrice}</span>
      </div>
    </Link>
  )
}
